<template>
  <section v-bind="sectionProps">
    <v-container v-bind="containerProps">
      <v-row v-bind="contentRowProps">
        <v-col v-bind="contentColumnProps">
          <div
            class="section-title"
            v-bind="titleProps"
            v-if="section.content.title"
            v-inline-editable.html="section.content.title"
          ></div>

          <div
            v-if="
              parseBoolean(section.layout['content-box']) &&
                section.layout['content-box-wrap'] == 'content'
            "
            v-bind="contentBoxProps"
          ></div>

          <v-row class="section-items" v-bind="itemRowProps">
            <v-col class="section-item" v-bind="itemColumnProps">
              <div class="item-content" v-bind="itemContentProps">
                <div
                  class="content-subtitle"
                  v-bind="subtitleProps"
                  v-if="section.content['content-subtitle']"
                  v-inline-editable.html="section.content['content-subtitle']"
                ></div>

                <div
                  class="content-text"
                  v-bind="textProps"
                  v-if="section.content['content-text']"
                  v-inline-editable.html="section.content['content-text']"
                ></div>

                <div
                  v-if="
                    parseBoolean(section.layout['content-box']) &&
                      section.layout['content-box-wrap'] == 'item'
                  "
                  v-bind="contentBoxProps"
                ></div>
              </div>
            </v-col>

            <v-col class="section-item" v-bind="itemColumnProps">
              <div class="item-content" v-bind="itemContentProps">
                <div
                  class="menu-subtitle"
                  v-bind="subtitleProps"
                  v-if="section.content['menu-subtitle']"
                  v-inline-editable.html="section.content['menu-subtitle']"
                ></div>

                <base-vertical-menu
                  :menu="section.content['menu']"
                  :props="menuItemProps"
                  :style="menuStyle"
                ></base-vertical-menu>

                <div
                  v-if="
                    parseBoolean(section.layout['content-box']) &&
                      section.layout['content-box-wrap'] == 'item'
                  "
                  v-bind="contentBoxProps"
                ></div>
              </div>
            </v-col>

            <v-col class="section-item" v-bind="itemColumnProps">
              <div class="item-content" v-bind="itemContentProps">
                <div
                  class="social-media-subtitle"
                  v-bind="subtitleProps"
                  v-if="section.content['social-media-subtitle']"
                  v-inline-editable.html="
                    section.content['social-media-subtitle']
                  "
                ></div>

                <div
                  v-if="
                    section.content['social-media'] &&
                      JSON.parse(section.content['social-media']).length
                  "
                >
                  <div
                    v-for="(social, index) in JSON.parse(
                      section.content['social-media']
                    )"
                    :key="index"
                  >
                    <v-btn
                      v-bind="socialMediaButtonProps"
                      :href="social['social-media-link']"
                      tile
                    >
                      <v-icon left
                        >md mdi-{{ social['social-media-icon'] }}</v-icon
                      >

                      {{ social['social-media-label'] }}
                    </v-btn>
                  </div>
                </div>

                <div
                  v-if="
                    parseBoolean(section.layout['content-box']) &&
                      section.layout['content-box-wrap'] == 'item'
                  "
                  v-bind="contentBoxProps"
                ></div>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>

    <parallax-background-image
      v-if="section.design['background-image']"
      :section="section"
      v-bind="backgroundImageProps"
    ></parallax-background-image>

    <slot name="toolbar"></slot>
  </section>
</template>

<script>
import ParallaxBackgroundImage from '@/components/sections/partials/elements/ParallaxBackgroundImage'
import BaseVerticalMenu from '@/components/sections/partials/menu/BaseVerticalMenu'

export default {
  name: 'FooterDefaultSection',
  props: {
    section: {
      type: Object,
      required: true
    },
    templateSettings: {
      type: Object,
      required: true
    },
    builder: {
      type: Boolean,
      default: true
    }
  },
  components: {
    ParallaxBackgroundImage,
    BaseVerticalMenu
  },
  computed: {
    sectionProps() {
      let additionalStyle = {}

      if (this.parseBoolean(this.section.design['custom-padding'])) {
        additionalStyle.paddingTop = this.section.design['padding-top']
        additionalStyle.paddingBottom = this.section.design['padding-bottom']
      }

      return {
        style: {
          backgroundColor: this.section.design['background-color'],
          ...additionalStyle
        }
      }
    },
    backgroundImageProps() {
      return {
        style: {
          height: '100%',
          position: 'absolute',
          top: 0,
          bottom: 0,
          left: 0,
          right: 0
        }
      }
    },
    containerProps() {
      return {
        'fill-height': true,
        fluid: this.parseBoolean(
          this.section.layout['content-container-fluid']
        ),
        style: {
          position: 'relative',
          zIndex: 1
        }
      }
    },
    contentRowProps() {
      return {
        'no-gutters': true,
        class: [
          `justify-${this.section.layout['content-horizontal-alignment']}`,
          `text-${this.section.layout['content-justify']}`
        ]
      }
    },
    contentColumnProps() {
      let additionalProps = {}

      if (!this.parseBoolean(this.section.layout['content-container-fluid'])) {
        additionalProps = {
          ...this.calculateColumnContainerSize(
            this.section.layout['content-container-size']
          )
        }
      }

      return {
        ...additionalProps,
        style: {
          position: 'relative',
          padding:
            this.parseBoolean(this.section.layout['content-box']) &&
            this.section.layout['content-box-wrap'] == 'content'
              ? this.section.layout['content-box-padding']
              : 0
        }
      }
    },
    itemRowProps() {
      return {
        class: {
          'mt-5':
            this.section.content['title'] || this.section.content['introtext']
        }
      }
    },
    itemColumnProps() {
      return {
        ...this.calculateColumns('3'),
        class: ['d-flex'],
        'flex-direction': 'column'
      }
    },
    itemContentProps() {
      return {
        style: {
          width: '100%',
          position: 'relative',
          padding:
            this.parseBoolean(this.section.layout['content-box']) &&
            this.section.layout['content-box-wrap'] == 'item'
              ? this.section.layout['content-box-padding']
              : 0
        }
      }
    },
    titleProps() {
      return {
        is: this.section.design['title-tag'],
        style: {
          color: this.section.design['title-color'],
          fontWeight: this.section.design['title-font-weight']
        }
      }
    },
    subtitleProps() {
      return {
        is: this.section.design['subtitle-tag'],
        style: {
          color: this.section.design['subtitle-color'],
          fontWeight: this.section.design['subtitle-font-weight']
        }
      }
    },
    textProps() {
      return {
        style: {
          color: this.section.design['text-color']
        }
      }
    },
    menuStyle() {
      let style = {}

      if (this.section.layout['content-justify'] == 'center') {
        style = {
          display: 'table !important',
          margin: '0 auto'
        }
      }

      return style
    },
    menuItemProps() {
      return {
        ripple: false,
        class: [`menu-active-style-${this.section.advanced['active-style']}`],
        tile: true,
        text: true,
        style: {
          fontSize: this.section.design['menu-font-size'],
          textTransform: 'none',
          color: this.section.design['menu-text-color']
        }
      }
    },
    socialMediaButtonProps() {
      return {
        class: ['mb-2'],
        color: 'transparent',
        depressed: true,
        target: '_blank'
      }
    },
    socialMediaIconProps() {
      return {}
    },
    contentBoxProps() {
      let additionalClass = []

      if (this.parseBoolean(this.section.layout['content-box-rounded'])) {
        additionalClass.push('rounded')
      }

      return {
        class: [
          `elevation-${this.section.layout['content-box-elevation']}`,
          ...additionalClass
        ],
        style: {
          position: 'absolute',
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: -1,
          backgroundColor: this.section.layout['content-box-color'],
          opacity: this.section.layout['content-box-opacity'],
          border: `${this.section.layout['content-box-border']}px solid ${this.section.layout['content-box-border-color']}`
        }
      }
    }
  }
}
</script>
